module.exports = __webpack_public_path__ + "img/mini_4073100852_85_partenaire-legrand-my-home_r2_c2.9648b429.png";